module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"更多":"More"},"zh":{"更多":"更多"}}')
  delete Component.options._Ctor
}
